import React from 'react';
import {
    Grid,
    Row,
    Col,
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import { withRouter } from 'react-router-dom';
import MessageCom from '../../layouts/Dashboard/Message';
import SimpleReactValidator from 'simple-react-validator';
import { userActions } from '../../redux/actions/user-actions';
import { connect } from 'react-redux';

class ForgotPasswordForm extends React.Component {
    constructor(props) {
        super(props);
        this.validatorUser = new SimpleReactValidator();
        this.state = {
            email: '',
            submitted: false,
            formType: this.props.formTypePro || '',
        };
        this.handleUser = this.handleUser.bind(this);
        this.handleUserSubmitForm = this.handleUserSubmitForm.bind(this);
    }
    handleUser(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }
    handleUserSubmitForm(e) {
        e.preventDefault();
        if (this.validatorUser.allValid()) {
            this.props.sendRecoveryEmailCall({ email: this.state.email }).then(res => {
                if (res.status === 'success')
                    this.props.history.goBack();
            })
        } else {
            this.setState({ submitted: false });
            this.validatorUser.showMessages();
            this.forceUpdate();
        }
    }

    render() {
        const { email } = this.state;
        return (
            <div>
                <MessageCom />
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                className="mt-lg"
                                ctTableResponsive
                                content={
                                    <div>
                                        <Grid fluid>
                                            <Row>
                                                <Col md={12}>
                                                    <div className="col-md-4 col-md-offset-4">
                                                        <form onSubmit={this.handleUserSubmitForm}>
                                                            <div className="col-md-12">
                                                                <div className='form-group relativeCard'>
                                                                    <label className="mb-xs mt-sm" htmlFor="email">Enter  Recovery Email Address<span className="requiredClass">*</span></label>
                                                                    <input type='text' autoComplete="off" name="email" className="form-control" value={email} onChange={this.handleUser} />
                                                                    {
                                                                        this.validatorUser.message('email', email, 'required|email')
                                                                    }
                                                                </div>
                                                            </div>

                                                            <div className="col-md-12">
                                                                <div className='text-center flexElem'>
                                                                    <button onClick={() => { this.props.history.goBack() }} type='button' className="customBtn btnBlack m-sm">Go Back</button>
                                                                    <button type='submit' className="customBtn btnBlue m-sm">Save</button>
                                                                </div>
                                                            </div>
                                                            <span></span>
                                                        </form>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Grid>
                                    </div>
                                } />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return ({
        sendRecoveryEmailCall: (data) => { return dispatch(userActions.sendRecoveryEmail(data)) },
    });
};

export default withRouter(connect(null, mapDispatchToProps)(ForgotPasswordForm));


// WEBPACK FOOTER //
// ./src/components/Admin/ForgotPasswordForm.jsx